import { Injectable, inject } from '@angular/core';

import { ConfirmationService } from '@abp/ng.theme.shared';

@Injectable({
  providedIn: 'root',
})
export class ErrorNotificationService {
  private confirmationService = inject(ConfirmationService);


  public show(messageText: string) {
    this.confirmationService.error(messageText, 'Mdd::Title:Error', {
      hideCancelBtn: true,
      yesText: 'AbpAccount::Close',
    });
  }
}
